import { render, staticRenderFns } from "./Tecnologias.vue?vue&type=template&id=4d9a7595&scoped=true&"
import script from "./Tecnologias.vue?vue&type=script&lang=js&"
export * from "./Tecnologias.vue?vue&type=script&lang=js&"
import style0 from "./Tecnologias.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Tecnologias.vue?vue&type=style&index=1&id=4d9a7595&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a7595",
  null
  
)

export default component.exports